export default function($) {
  var speed = 90; // ms

  $('.js-open-search-mobile').click(function () {
    $('.js-search-form').slideToggle(speed);
    $(this).find('.search-open').toggleClass('hidden');
    $(this).find('.search-close').toggleClass('hidden');
  });
}
